import React from 'react'
// import {v4 as uuid} from 'uuid'

import Ui from './index.ui'

function ModulosPeopleContainer() {

    const dataCompare = {
        items:[],
        isFetching: false,
    }
    return (
        <Ui 
            dataCompare={dataCompare}
        />
        )
    }

export default ModulosPeopleContainer
